import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { getPost as universalGetPost, getPostBySlug as universalGetPostBySlug, queryPosts as universalQueryPosts, viewPost as universalViewPost, markPostRead as universalMarkPostRead, markPostsSeen as universalMarkPostsSeen, markPostUnread as universalMarkPostUnread, createPost as universalCreatePost, updatePost as universalUpdatePost, deletePost as universalDeletePost, setBestAnswer as universalSetBestAnswer, removeBestAnswer as universalRemoveBestAnswer, pinPost as universalPinPost, unpinPost as universalUnpinPost, addReaction as universalAddReaction, removeReaction as universalRemoveReaction, reportPost as universalReportPost, } from './forum-v1-post.universal';
import { PostType, Interaction, EntityType, IdentityType, ReportType, PostFieldField, Field, Order, WebhookIdentityType, } from './forum-v1-post.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.forum.v1.post', module_name: 'wix-forum.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        getPost: (postId, options) => {
            const methodLogData = {
                method_name: 'getPost',
                service_name: 'com.wixpress.npm.communities.forum.api.PostManagementService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forum.v2,entity=wix.forum.v1.post,environment=velo-frontend,method-fqn=com.wixpress.npm.communities.forum.api.PostManagementService.getPost',
            };
            return universalGetPost(postId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getPostBySlug: (slug, options) => {
            const methodLogData = {
                method_name: 'getPostBySlug',
                service_name: 'com.wixpress.npm.communities.forum.api.PostManagementService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forum.v2,entity=wix.forum.v1.post,environment=velo-frontend,method-fqn=com.wixpress.npm.communities.forum.api.PostManagementService.getPostBySlug',
            };
            return universalGetPostBySlug(slug, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryPosts: (options) => {
            const methodLogData = {
                method_name: 'queryPosts',
                service_name: 'com.wixpress.npm.communities.forum.api.PostManagementService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forum.v2,entity=wix.forum.v1.post,environment=velo-frontend,method-fqn=com.wixpress.npm.communities.forum.api.PostManagementService.queryPosts',
            };
            return universalQueryPosts(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        viewPost: (postId) => {
            const methodLogData = {
                method_name: 'viewPost',
                service_name: 'com.wixpress.npm.communities.forum.api.PostManagementService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forum.v2,entity=wix.forum.v1.post,environment=velo-frontend,method-fqn=com.wixpress.npm.communities.forum.api.PostManagementService.viewPost',
            };
            return universalViewPost(postId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        markPostRead: (postId) => {
            const methodLogData = {
                method_name: 'markPostRead',
                service_name: 'com.wixpress.npm.communities.forum.api.PostManagementService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forum.v2,entity=wix.forum.v1.post,environment=velo-frontend,method-fqn=com.wixpress.npm.communities.forum.api.PostManagementService.markPostRead',
            };
            return universalMarkPostRead(postId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        markPostsSeen: (options) => {
            const methodLogData = {
                method_name: 'markPostsSeen',
                service_name: 'com.wixpress.npm.communities.forum.api.PostManagementService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forum.v2,entity=wix.forum.v1.post,environment=velo-frontend,method-fqn=com.wixpress.npm.communities.forum.api.PostManagementService.markPostsSeen',
            };
            return universalMarkPostsSeen(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        markPostUnread: (postId) => {
            const methodLogData = {
                method_name: 'markPostUnread',
                service_name: 'com.wixpress.npm.communities.forum.api.PostManagementService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forum.v2,entity=wix.forum.v1.post,environment=velo-frontend,method-fqn=com.wixpress.npm.communities.forum.api.PostManagementService.markPostUnread',
            };
            return universalMarkPostUnread(postId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        createPost: (options) => {
            const methodLogData = {
                method_name: 'createPost',
                service_name: 'com.wixpress.npm.communities.forum.api.PostManagementService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forum.v2,entity=wix.forum.v1.post,environment=velo-frontend,method-fqn=com.wixpress.npm.communities.forum.api.PostManagementService.createPost',
            };
            return universalCreatePost(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updatePost: (postId, options) => {
            const methodLogData = {
                method_name: 'updatePost',
                service_name: 'com.wixpress.npm.communities.forum.api.PostManagementService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forum.v2,entity=wix.forum.v1.post,environment=velo-frontend,method-fqn=com.wixpress.npm.communities.forum.api.PostManagementService.updatePost',
            };
            return universalUpdatePost(postId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        deletePost: (postId) => {
            const methodLogData = {
                method_name: 'deletePost',
                service_name: 'com.wixpress.npm.communities.forum.api.PostManagementService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forum.v2,entity=wix.forum.v1.post,environment=velo-frontend,method-fqn=com.wixpress.npm.communities.forum.api.PostManagementService.deletePost',
            };
            return universalDeletePost(postId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        setBestAnswer: (postId, commentId) => {
            const methodLogData = {
                method_name: 'setBestAnswer',
                service_name: 'com.wixpress.npm.communities.forum.api.PostManagementService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forum.v2,entity=wix.forum.v1.post,environment=velo-frontend,method-fqn=com.wixpress.npm.communities.forum.api.PostManagementService.setBestAnswer',
            };
            return universalSetBestAnswer(postId, commentId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        removeBestAnswer: (postId) => {
            const methodLogData = {
                method_name: 'removeBestAnswer',
                service_name: 'com.wixpress.npm.communities.forum.api.PostManagementService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forum.v2,entity=wix.forum.v1.post,environment=velo-frontend,method-fqn=com.wixpress.npm.communities.forum.api.PostManagementService.removeBestAnswer',
            };
            return universalRemoveBestAnswer(postId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        pinPost: (postId, options) => {
            const methodLogData = {
                method_name: 'pinPost',
                service_name: 'com.wixpress.npm.communities.forum.api.PostManagementService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forum.v2,entity=wix.forum.v1.post,environment=velo-frontend,method-fqn=com.wixpress.npm.communities.forum.api.PostManagementService.pinPost',
            };
            return universalPinPost(postId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        unpinPost: (postId) => {
            const methodLogData = {
                method_name: 'unpinPost',
                service_name: 'com.wixpress.npm.communities.forum.api.PostManagementService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forum.v2,entity=wix.forum.v1.post,environment=velo-frontend,method-fqn=com.wixpress.npm.communities.forum.api.PostManagementService.unpinPost',
            };
            return universalUnpinPost(postId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        addReaction: (postId, reactionCode) => {
            const methodLogData = {
                method_name: 'addReaction',
                service_name: 'com.wixpress.npm.communities.forum.api.PostManagementService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forum.v2,entity=wix.forum.v1.post,environment=velo-frontend,method-fqn=com.wixpress.npm.communities.forum.api.PostManagementService.addReaction',
            };
            return universalAddReaction(postId, reactionCode, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        removeReaction: (postId, reactionCode) => {
            const methodLogData = {
                method_name: 'removeReaction',
                service_name: 'com.wixpress.npm.communities.forum.api.PostManagementService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forum.v2,entity=wix.forum.v1.post,environment=velo-frontend,method-fqn=com.wixpress.npm.communities.forum.api.PostManagementService.removeReaction',
            };
            return universalRemoveReaction(postId, reactionCode, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        reportPost: (postId, options) => {
            const methodLogData = {
                method_name: 'reportPost',
                service_name: 'com.wixpress.npm.communities.forum.api.PostManagementService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-forum.v2,entity=wix.forum.v1.post,environment=velo-frontend,method-fqn=com.wixpress.npm.communities.forum.api.PostManagementService.reportPost',
            };
            return universalReportPost(postId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        PostType,
        Interaction,
        EntityType,
        IdentityType,
        ReportType,
        PostFieldField,
        Field,
        Order,
        WebhookIdentityType,
    };
}
//# sourceMappingURL=forum-v1-post.frontend.js.map